var _ellipse, _ellipse2, _ellipse3, _ellipse4, _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsBotOutlineBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.75,
    cy: 32.07,
    rx: 3.08,
    ry: 3.11
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.25,
    cy: 32.07,
    rx: 3.08,
    ry: 3.11
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.15,
    cy: 62.9,
    rx: 2.29,
    ry: 2.31
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.15,
    cy: 71.59,
    rx: 2.29,
    ry: 2.31
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.52,
    y: 60.86,
    width: 8.28,
    height: 4.36
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51.52,
    y: 69.09,
    width: 8.28,
    height: 7.92
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.08,50.67H54.14V46.5h16V29.11A8.16,8.16,0,0,0,62,20.92H52.22V14H47.78v6.92H38a8.16,8.16,0,0,0-8.14,8.19V46.5h16v4.17H37.92c-8,0-14.92,5.9-14.92,10.73V86H77V64.39C77,56.82,70.31,50.67,62.08,50.67ZM34.76,29.11A3.21,3.21,0,0,1,38,25.89H62a3.21,3.21,0,0,1,3.2,3.22V41.53H34.76ZM72.55,81.52H27.45V61.4c0-1.86,4.42-6.25,10.47-6.25H62.08c5.78,0,10.47,4.14,10.47,9.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBotOutlineBrand);
export default __webpack_public_path__ + "static/media/Icons_Bot_Outline_Brand.f3482630503894986829662347d03876.svg";
export { ForwardRef as ReactComponent };